export const OPPORTUNITY_TYPES = [
  { value: "higher_education", label: "Higher Education" },
  { value: "apprenticeship", label: "Apprenticeships" },
  { value: "professional_qualification", label: "Professional" },
  { value: "online_learning", label: "Online Learning" },
  { value: "training", label: "Training" },
  { value: "other", label: "Other" },
];

export const QUALIFICATION_LEVELS = [
  { value: "undergraduate", label: "Undergraduate" },
  { value: "postgraduate", label: "Postgraduate" },
  { value: "degree_apprenticeship", label: "Degree apprenticeship" },
  { value: "professional", label: "Professional" },
  { value: "training", label: "Training" },
  { value: "short_course", label: "Short course" },
];

export const STUDY_MODES = ["Full-time", "Part-time", "Flexible"];

export const typeLabel = (value) =>
  OPPORTUNITY_TYPES.find((t) => t.value === value)?.label || value || "Other";

export const levelLabel = (value) =>
  QUALIFICATION_LEVELS.find((l) => l.value === value)?.label || (value || "Not specified").replace(/_/g, " ");

export const statusLabel = (value) => (value || "unknown").replace(/_/g, " ");

export const formatDate = (value) => {
  if (!value) return "To be confirmed";
  const date = new Date(`${value}T00:00:00`);
  if (Number.isNaN(date.getTime())) return value;
  return date.toLocaleDateString("en-GB", { day: "numeric", month: "short", year: "numeric" });
};

export const providerInitials = (name = "") =>
  name.split(" ").filter(Boolean).map((part) => part[0]).slice(0, 2).join("").toUpperCase() || "OP";

export const compactList = (items, fallback = "Not specified") =>
  Array.isArray(items) && items.length ? items.join(", ") : fallback;
